import { type FixedIncomeProduct } from 'investments/common/entities'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils'

async function fetchFixedIncomeProductDetails({ productId, accountId }: { productId: string; accountId: string }) {
  const { data } = await httpClientBanking<FixedIncomeProduct>({
    url: `/investments/accounts/${accountId}/fixed_income_products/${productId}`
  })
  return data
}

export function useFetchFixedIncomeProductDetails({
  productId,
  accountId,
  enabled
}: {
  productId: string
  accountId: string
  enabled?: boolean
}) {
  const {
    data: fixedIncomeProductData,
    isSuccess: isFixedIncomeProductSuccess,
    isError: isFixedIncomeProductError,
    isLoading: isFixedIncomeProductLoading,
    isRefetching: isFixedIncomeProductRefetching,
    isFetching: isFixedIncomeProductFetching
  } = useQueryRequest<FixedIncomeProduct, unknown, true>(
    ['useFetchFixedIncomeProductDetails', accountId, productId],
    () => fetchFixedIncomeProductDetails({ accountId, productId }),
    { enabled: enabled ?? Boolean(accountId && productId), suspense: true }
  )

  return {
    fixedIncomeProductData,
    isFixedIncomeProductSuccess,
    isFixedIncomeProductError,
    isFixedIncomeProductLoading,
    isFixedIncomeProductFetching,
    isFixedIncomeProductRefetching
  }
}
